import APIClient from '@/shared/http/clients/api'

const resourceName = 'expertrouteview'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const SearchPaging = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const Search = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/search`, data, config)
const SendEmail = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/sendmail`, data, config)
const Export = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/export`, data, config)

const ExpertRouteViewRepository = {

  Search,
  SearchPaging,
  SendEmail,
  Export
}

export default ExpertRouteViewRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/expertroutes/expertrouteview.js